import { formatPostalCode } from '@/utils/convert/formatPostalCode';
import { useCallback } from 'react';

export const usePostalCodeFormat = (onChange: (value: string) => void) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const formatted = formatPostalCode(e.target.value);
      onChange(formatted);
    },
    [onChange]
  );

  return { handleChange };
};
